import { useState, useEffect } from "react";

const getPageState = () =>
  document.documentElement.dataset.pageState ?? "home";

export const usePageState = () => {
  const [pageState, setPageState] = useState(getPageState);

  useEffect(() => {
    const html = document.documentElement;
    let previousState = html.dataset.pageState;
    const observer = new MutationObserver(() => {
      const nextState = html.dataset.pageState;
      if (nextState && nextState !== previousState) {
        setPageState(nextState);
        previousState = nextState;
      }
    });
    observer.observe(html, {
      attributes: true,
      attributeFilter: ["data-page-state"],
    });
    return () => observer.disconnect();
  }, []);

  return pageState;
};
